import coxsBazar from './Images/Sajek.png';
import sreemangal from './Images/Sreemongol.png';
import sundarban from './Images/sundorbon.png';


let fakeData = [
    {
        key:'B104LC',
        name: "COX'S BAZAR",
        description:"Cox’s Bazar is a town on the southeast coast of Bangladesh. It’s known for its very long, sandy beachfront, stretching from Sea Beach in the north to Kolatoli Beach in the south. Aggameda Khyang monastery is home to bronze statues and centuries-old Buddhist manuscripts.",
        image: coxsBazar
    },{
        key:'B104Ld',
        name: "SREEMANGAL",
        description:"Sreemangal is situated in Moulvibazar district in sylhet division. Sreemangal is an Upazila. It is famous for tea garden. Rain all time occurs here. Nature has adorned sreemangal with green tress. Its natural scenery is very charming.",
        image:sreemangal
    },
    {
        key:'B104Le',
        name: "SUNDARBANS",
        description:"The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India's state of West Bengal to the Baleswar River in Bangladesh.",
        image:sundarban
    }
]
export default fakeData;